// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2437":"d500b872173011eb","3221":"172a7fec2898fdb5","4883":"ef550c80550aff1c","9047":"a5c040a14581ac12","9408":"0e785b558a2c0b64"}[chunkId] + ".css";
};